(() => {
  if (window.__appleCollectionCarouselInitialized) return;
  window.__appleCollectionCarouselInitialized = true;

  function normalize(v) {
    return (v || "").toString().trim().toLowerCase();
  }

  function getVariants(cardEl) {
    const script = cardEl.querySelector("script[data-variants-json]");
    if (!script) return [];
    try {
      const parsed = JSON.parse(script.textContent || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function setActiveSwatch(cardEl, activeBtn) {
    cardEl.querySelectorAll("[data-swatch]").forEach((b) => b.classList.remove("is-active"));
    activeBtn.classList.add("is-active");
  }

  function findVariantForSwatch(variants, pos, val) {
    const key = pos === 1 ? "option1" : pos === 2 ? "option2" : pos === 3 ? "option3" : null;
    if (!key) return null;

    const target = normalize(val);

    // Prefer a matching variant that actually has an image
    const withImg = variants.find((v) => normalize(v[key]) === target && v.img);
    if (withImg) return withImg;

    return variants.find((v) => normalize(v[key]) === target) || null;
  }

  function swapCardImage(cardEl, variant) {
    if (!variant) return;

    const imgEl = cardEl.querySelector("img[data-card-image]");
    if (imgEl && variant.img) {
      imgEl.src = variant.img;
      imgEl.removeAttribute("srcset"); // fast + consistent swap
    }

    const mediaLink = cardEl.querySelector(".acc-card__media");
    if (mediaLink && variant.url) mediaLink.href = variant.url;

    const buyLink = cardEl.querySelector("[data-acc-buy]");
    if (buyLink && variant.url) {
      if (buyLink.tagName === "A") buyLink.href = variant.url;
      buyLink.dataset.productUrl = variant.url;
    }
  }

  // --- GUTTER ALIGNMENT (SPACER METHOD) ---
function setTrackGutter(section) {
  const title = section.querySelector("[data-acc-title]");
  const viewport = section.querySelector("[data-acc-viewport]");
  if (!title || !viewport) return;

  const titleLeft = title.getBoundingClientRect().left;
  const vpLeft = viewport.getBoundingClientRect().left;

  const gutter = Math.max(0, Math.round(titleLeft - vpLeft));
  section.style.setProperty("--acc-track-gutter", `${gutter}px`);
}

  function refreshAllGutters() {
    document.querySelectorAll("[data-acc]").forEach((section) => setTrackGutter(section));
  }

  // --- SWATCH CLICK ---
  document.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-acc] [data-swatch]");
    if (!btn) return;

    const card = btn.closest("[data-product-card]");
    if (!card) return;

    e.preventDefault();

    const pos = parseInt(btn.getAttribute("data-option-position"), 10);
    const val = btn.getAttribute("data-option-value");

    const variants = getVariants(card);
    if (!variants.length || !pos || !val) return;

    setActiveSwatch(card, btn);
    const match = findVariantForSwatch(variants, pos, val);
    swapCardImage(card, match);
  });

  // --- CHEVRONS: SMOOTH NEXT-CARD ANIMATION ---
function initCarousel(section) {
  // Guard: prevent duplicate bindings (theme editor / script included twice)
  if (section.__accNavBound) return;
  section.__accNavBound = true;

  const track = section.querySelector("[data-acc-track]");
  const prev = section.querySelector("[data-acc-prev]");
  const next = section.querySelector("[data-acc-next]");
  if (!track || (!prev && !next)) return;

  function pop(btn) {
    if (!btn) return;
    btn.classList.remove("is-popping");
    void btn.offsetWidth;
    btn.classList.add("is-popping");
  }

  function getGutterPx() {
    const v = getComputedStyle(section).getPropertyValue("--acc-track-gutter").trim();
    const n = parseFloat(v);
    return Number.isFinite(n) ? n : 0;
  }

  function cards() {
    return Array.from(track.querySelectorAll(".acc-card"));
  }

  function clamp(x) {
    const max = Math.max(0, track.scrollWidth - track.clientWidth);
    return Math.max(0, Math.min(x, max));
  }

  function easeInOutCubic(t) {
    return t < 0.5
      ? 4 * t * t * t
      : 1 - Math.pow(-2 * t + 2, 3) / 2;
  }

  let animationFrame = null;
  let animationDone = null;
  let animationResolve = null;
  let animationRestoreSnap = null;

  function animateTo(left) {
    const target = clamp(left);
    const start = track.scrollLeft;
    const delta = target - start;

    if (Math.abs(delta) < 2) {
      track.scrollLeft = target;
      return Promise.resolve();
    }

    if (animationFrame) {
      cancelAnimationFrame(animationFrame);
      animationFrame = null;
    }

    if (animationRestoreSnap) {
      animationRestoreSnap();
      animationRestoreSnap = null;
    }

    if (animationResolve) {
      animationResolve();
      animationResolve = null;
    }

    const duration = 420;
    const startedAt = performance.now();
    const previousSnapType = track.style.scrollSnapType;
    track.style.scrollSnapType = "none";
    animationRestoreSnap = () => {
      track.style.scrollSnapType = previousSnapType;
    };

    animationDone = new Promise((resolve) => {
      animationResolve = resolve;

      function step(now) {
        const elapsed = now - startedAt;
        const progress = Math.min(1, elapsed / duration);
        const eased = easeInOutCubic(progress);

        track.scrollLeft = start + delta * eased;

        if (progress < 1) {
          animationFrame = requestAnimationFrame(step);
          return;
        }

        track.scrollLeft = target;
        animationFrame = null;

        requestAnimationFrame(() => {
          if (animationRestoreSnap) {
            animationRestoreSnap();
            animationRestoreSnap = null;
          }
          animationResolve = null;
          resolve();
        });
      }

      animationFrame = requestAnimationFrame(step);
    });

    return animationDone;
  }

  function currentIndex() {
    const cs = cards();
    if (!cs.length) return 0;

    const gutter = getGutterPx();
    const s = track.scrollLeft;

    let best = 0;
    let bestDist = Infinity;

    cs.forEach((c, i) => {
      const leftAtViewport = c.offsetLeft - s;
      const dist = Math.abs(leftAtViewport - gutter);
      if (dist < bestDist) {
        bestDist = dist;
        best = i;
      }
    });

    return best;
  }

  function scrollToIndex(idx) {
    const cs = cards();
    if (!cs.length) return Promise.resolve();

    const gutter = getGutterPx();
    const i = Math.max(0, Math.min(idx, cs.length - 1));
    const trackRect = track.getBoundingClientRect();
    const cardRect = cs[i].getBoundingClientRect();
    const target = clamp(track.scrollLeft + (cardRect.left - trackRect.left) - gutter);

    return animateTo(target);
  }

  function updateDisabled() {
    if (!prev || !next) return;
    const idx = currentIndex();
    const cs = cards();
    prev.disabled = idx <= 0;
    next.disabled = idx >= cs.length - 1;
  }

  // Lock while animating so no queued double steps
  let locked = false;
  let unlockTimer = null;

  function lockBriefly() {
    locked = true;
    clearTimeout(unlockTimer);
  }

  let scrollEndTimer = null;
  track.addEventListener(
    "scroll",
    () => {
      updateDisabled();
      if (!locked) return;
      clearTimeout(scrollEndTimer);
      scrollEndTimer = setTimeout(updateDisabled, 60);
    },
    { passive: true }
  );

  function nav(dir, btn) {
    if (locked) return;
    lockBriefly();
    pop(btn);
    scrollToIndex(currentIndex() + dir).finally(() => {
      locked = false;
      updateDisabled();
    });
  }

  // Use pointerup as the ONLY trigger
  function bindBtn(btn, dir) {
    if (!btn) return;

    btn.addEventListener(
      "pointerup",
      (e) => {
        e.preventDefault();
        e.stopPropagation();
        nav(dir, btn);
      },
      { passive: false }
    );

    // Kill ghost clicks
    btn.addEventListener(
      "click",
      (e) => {
        e.preventDefault();
        e.stopPropagation();
      },
      { passive: false }
    );
  }

  bindBtn(prev, -1);
  bindBtn(next, 1);

  window.addEventListener("resize", updateDisabled);
  updateDisabled();
}

  // --- PREFETCH VARIANT IMAGES ON HOVER ---
  function prefetch(url) {
    if (!url) return;
    const img = new Image();
    img.decoding = "async";
    img.src = url;
  }

  document.addEventListener("mouseenter", (e) => {
    const card = e.target.closest("[data-acc] [data-product-card]");
    if (!card || card.__accPrefetched) return;
    const variants = getVariants(card);
    card.__accPrefetched = true;
    variants.forEach((v) => v.img && prefetch(v.img));
  }, true);

  // --- INIT ---
  function initAll() {
    refreshAllGutters();
    document.querySelectorAll("[data-acc]").forEach((section) => initCarousel(section));
  }

  window.addEventListener("resize", refreshAllGutters);
  document.addEventListener("DOMContentLoaded", initAll);
  initAll();
})();
